import {
  type ApiKeyTagCatalog,
  countApiKeys,
  getApiKeyTagCatalog,
  listApiKeys,
  parseApiKeyMetadata,
} from '@mesa/core/auth/api-keys';
import { createServerFn } from '@tanstack/react-start';
import { log } from '../../lib/logger';
import { assertScope, baseAuthMiddleware } from '../../middleware/base-auth';

export const loadTokensPage = createServerFn({ method: 'GET' })
  .middleware([baseAuthMiddleware])
  .inputValidator(
    (data: { orgSlug: string; cursor?: string; search?: string; tags?: string[]; limit?: number }) => data
  )
  .handler(async ({ data, context }) => {
    assertScope(context.member.role, 'read');
    const orgId = context.org.id;
    const status = 'active' as const;
    const tags = data.tags?.length ? data.tags.join(',') : undefined;

    const [result, tagCatalog, totalCount] = await Promise.all([
      listApiKeys(orgId, {
        cursor: data.cursor,
        limit: data.limit ?? 10,
        query: data.search || undefined,
        status,
        tags,
      }),
      getApiKeyTagCatalog(orgId).catch((err): ApiKeyTagCatalog => {
        log.warn('api-key-tag-catalog-failed', { orgId, error: String(err) });
        return {};
      }),
      countApiKeys(orgId, { query: data.search || undefined, status, tags }),
    ]);

    const apiKeys = result.apiKeys.map(({ createdAtCursor: _, metadata, ...key }) => ({
      ...key,
      tags: parseApiKeyMetadata(metadata).tags,
    }));

    return {
      apiKeys,
      nextCursor: result.nextCursor,
      hasMore: result.hasMore,
      totalCount,
      tagCatalog,
    };
  });
